<template>
  <div class="chart-editor-setting-value">
    <span
      v-if="value"
      class="_value"
    >
      {{ value }}
    </span>
    <m-icon
      type="right"
      :color="$colors.grey.lighten1"
      size="11"
    />
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: [String, Number],
    default: '',
  },
});
</script>

<style scoped lang="scss" type="text/scss">
  .chart-editor-setting-value {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    min-width: 0;

    ._value {
      color: $font-color-secondary;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
    }
  }
</style>
